import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import type { V2_MetaFunction } from "@remix-run/react";
import { Link, useLoaderData } from "@remix-run/react";
import type { ScrapeJob, ScrapeJobResponse } from "../../models/scrapejobs";

export const meta: V2_MetaFunction = () => {
  return [{ title: "Uncore Metrics" }];
};

export const loader = async (): Promise<ScrapeJobResponse> => {
  const response = await fetch(`https://api.uncore.app/v1/jobs`);
  return await response.json();
};
function returnEntryRow(row: ScrapeJob) {
  return (
    <TableRow
      key={row.name}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        {row.gameType}
      </TableCell>
      <TableCell align="right">{row.progress}%</TableCell>
      <TableCell align="right">{row.runType}</TableCell>
      <TableCell align="right">{row.totalCount}</TableCell>
      <TableCell align="right">{row.totalDone}</TableCell>
      <TableCell align="right">
        {new Date(row.startedAt).toLocaleTimeString()}
      </TableCell>
      <TableCell align="right">
        {new Date(row.lastUpdateUtc).toLocaleTimeString()}
      </TableCell>
      <TableCell align="right">{row.node}</TableCell>
      <TableCell align="right">{row.running.toString()}</TableCell>
    </TableRow>
  );
}

export default function Index() {
  const { data } = useLoaderData<typeof loader>();
  return (
    <div style={{ fontFamily: "system-ui, sans-serif", lineHeight: "1.4" }}>
      <div className="flex min-h-screen flex-col items-center justify-center py-2">
        <main
          className="flex w-full flex-1 flex-col items-center justify-center px-20 text-center"
          suppressHydrationWarning
        >
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Game</TableCell>
                  <TableCell align="right">Progress</TableCell>
                  <TableCell align="right">Run Type</TableCell>
                  <TableCell align="right">Run Count</TableCell>
                  <TableCell align="right">Run Done</TableCell>
                  <TableCell align="right">Started At</TableCell>
                  <TableCell align="right">Last Update</TableCell>
                  <TableCell align="right">Node Name</TableCell>
                  <TableCell align="right">Is Running</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(data == null ? [] : data)
                  .filter((scrapejob) => scrapejob.running)
                  .sort(
                    (a, b) =>
                      new Date(b.lastUpdateUtc).getMilliseconds() -
                      new Date(a.lastUpdateUtc).getMilliseconds()
                  )
                  .map((row) => returnEntryRow(row))}
                {(data == null ? [] : data)
                  .filter((scrapejob) => !scrapejob.running)
                  .sort(
                    (a, b) =>
                      new Date(b.lastUpdateUtc).getMilliseconds() -
                      new Date(a.lastUpdateUtc).getMilliseconds()
                  )
                  .map((row) => returnEntryRow(row))}
              </TableBody>
            </Table>
          </TableContainer>
        </main>

        <footer className="flex h-24 w-full items-center justify-center border-t space-x-2">
          <a
            className="flex items-center justify-center gap-2"
            href="https://github.com/Tyler-OBrien/UncoreMetrics"
            target="_blank"
            rel="noopener noreferrer"
          >
            Powered by Uncore Metrics
          </a>
          <span className="flex">|</span>
          <a className="flex  justify-center gap-2" href="/about">
            About
          </a>
        </footer>
      </div>
    </div>
  );
}
